import clubRequest from "../axios";
import {
  CalculateRegionSmsAmountPayload,
  GetAreaPayload,
  SendSmsRegionRequestPayload,
} from "./type";

const getArea = async (command: GetAreaPayload) =>
  (await clubRequest.regionList(command)).data;

const calculatePrice = async (command: CalculateRegionSmsAmountPayload) =>
  (await clubRequest.smsCalculateRegionSmsAmountCreate(command)).data;

const sendSms = async (command: SendSmsRegionRequestPayload) =>
  (await clubRequest.smsSendRegionRequestCreate(command)).data;

export const AreaMessageService = {
  getArea,
  calculatePrice,
  sendSms,
};
